// Modules
import React from 'react';

import TriageDashboard from 'routes/dashboards/triage';
import UserDashboard from 'routes/dashboards/user';

export default function Dashboard() {
  return (
    <div className="d-flex flex-equal-children">
      <div style={{ width: '50%' }}>
        <UserDashboard />
      </div>
      <div style={{ width: '50%' }}>
        <TriageDashboard />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/routes/dashboards/dashboard.js